import React, { Component } from "react";
import { Form, Grid, Header, Segment } from "semantic-ui-react";

class ContactInfo extends Component {
  render() {
    return (
      <Form color="blue">
        <Grid columns="equal">
          <Grid.Column>
            <Segment>
              <Header>NON-PROFIT PRIMARY CONTACT</Header>
              <Form.Field>
                <label>First Name:</label>
                <Form.Input
                  placeholder="First Name"
                  name="pri_first_name"
                  value={this.props.profile.pri_first_name}
                  onChange={this.props.handleChange}
                />
              </Form.Field>
              <Form.Field>
                <label>Last Name:</label>
                <Form.Input
                  placeholder="Last Name"
                  name="pri_last_name"
                  value={this.props.profile.pri_last_name}
                  onChange={this.props.handleChange}
                />
              </Form.Field>
              <Form.Field>
                <label>Title:</label>
                <select
                  value={this.props.profile.pri_title}
                  name="pri_title"
                  onChange={this.props.handleChange}
                >
                  <option>Mr.</option>
                  <option>Ms.</option>
                  <option>Mrs.</option>
                </select>
              </Form.Field>
              <Form.Field>
                <label>Telephone Number:</label>
                <Form.Input
                  placeholder="Telephone Number"
                  name="pri_phone_number"
                  value={this.props.profile.pri_phone_number}
                  onChange={this.props.handleChange}
                />
              </Form.Field>
              <Form.Field>
                <label>Fax Number:</label>
                <Form.Input
                  placeholder="Fax Number"
                  name="pri_fax_number"
                  value={this.props.profile.pri_fax_number}
                  onChange={this.props.handleChange}
                />
              </Form.Field>
              <Form.Field>
                <label>Email Address:</label>
                <Form.Input
                  type="email"
                  placeholder="Email Address"
                  name="pri_email"
                  value={this.props.profile.pri_email}
                  onChange={this.props.handleChange}
                />
              </Form.Field>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment>
              <Header>NON-PROFIT EMERGENCY CONTACT</Header>
              <Form.Field>
                <label>First Name:</label>
                <Form.Input
                  placeholder="First Name"
                  name="emg_first_name"
                  value={this.props.profile.emg_first_name}
                  onChange={this.props.handleChange}
                />
              </Form.Field>
              <Form.Field>
                <label>Last Name:</label>
                <Form.Input
                  placeholder="Last Name"
                  name="emg_last_name"
                  value={this.props.profile.emg_last_name}
                  onChange={this.props.handleChange}
                />
              </Form.Field>
              <Form.Field>
                <label>Title:</label>
                <select
                  name="emg_title"
                  value={this.props.profile.emg_title}
                  onChange={this.props.handleChange}
                >
                  <option>Mr.</option>
                  <option>Ms.</option>
                  <option>Mrs.</option>
                </select>
              </Form.Field>
              <Form.Field>
                <label>Telephone Number:</label>
                <Form.Input
                  placeholder="Telephone Number"
                  name="emg_phone_number"
                  value={this.props.profile.emg_phone_number}
                  onChange={this.props.handleChange}
                />
              </Form.Field>
              <Form.Field>
                <label>Fax Number:</label>
                <Form.Input
                  placeholder="Fax Number"
                  name="emg_fax_number"
                  value={this.props.profile.emg_fax_number}
                  onChange={this.props.handleChange}
                />
              </Form.Field>
              <Form.Field>
                <label>Email Address:</label>
                <Form.Input
                  type="email"
                  placeholder="Email Address"
                  name="emg_email"
                  value={this.props.profile.emg_email}
                  onChange={this.props.handleChange}
                />
              </Form.Field>
            </Segment>
          </Grid.Column>
        </Grid>
        <Form.Group inline>
          <Form.Button
            size="large"
            onClick={() => this.props.handleStep("non-profit-info")}
          >
            Go Back{" "}
          </Form.Button>
          <Form.Button
            primary
            size="large"
            onClick={() => this.props.handleStep("foundation-info")}
          >
            Save And Continue{" "}
          </Form.Button>
        </Form.Group>
      </Form>
    );
  }
}

export default ContactInfo;
